import Unsplash, {toJson} from 'unsplash-js';

let FJUnsplashStore = (function () {
  let unsplash = new Unsplash({
    applicationId: "2aa9a1e5ea161790ed085b55335b6b6ee8976b46e94b43e4d4432e7af472930f",
    secret: "ddd3d3cf7157e7211c8e28a7689669261f3b2814597c43b64ca9ea5a4830a3d1",
  });

  return {
    search: function (keyword, page, per_page = 30, success, error) {
      unsplash.search.photos(keyword, page, per_page)
        .then(toJson)
        .then(json => {
          if (json.errors) {
            error();
          } else {
            success(json);
          }
        })
        .catch(() => {
          error();
        });
    },
    getPhoto: function (id) {
      return new Promise((resolve, reject) => {
        unsplash.photos.getPhoto(id)
          .then(toJson)
          .then(json => {
            // Your code
            resolve(json);
          })
          .catch(reject);
      })
    },

    /**
     * @description 版权原因。在下载unsplash的相关资源时调用此方法方面unsplash内部的统计
     * @param photo
     */
    downloadPhoto: function (photo) {
      unsplash.photos.downloadPhoto(photo);
    },
  };
})();

export default FJUnsplashStore;